import styled from 'styled-components';
import React from 'react';
import {Popconfirm, Icon, Tooltip} from 'antd';
import Button from './StyledButton';

const DeleteButton = styled(Button)`
   &:hover {
    color: #ffffff;
    background-color: #f5222d;
    border-color: #f5222d;
   }              
`;

export default ({ deleteFn, id, entityType }) => (
  <Popconfirm
    placement="topRight"
    title={`Are you sure you want to delete this${entityType ? ` ${entityType}` : ''}?`}
    onConfirm={() => deleteFn(id)}
    okText="Delete"
    cancelText="Cancel"
  >
    <Tooltip placement="topRight" title={'Delete Category'}>
      <DeleteButton
        size="small"
      >
        <Icon type="delete" />
      </DeleteButton>
    </Tooltip>
  </Popconfirm>
);
